import { useCallback } from 'react';

import { isDefined } from '@hsp/utilities';

import { IClient } from 'types/api/client';

export const useDisplayValue = () => {
  return useCallback((client: IClient) => {
    const { acronym, name } = client;
    let names: string[] = [name];

    if (isDefined(acronym)) {
      names = [...names, `(${acronym})`];
    }

    return names.join(' ');
  }, []);
};
